export class ChartB2BB2CData {
  public constructor (
    readonly year: string,
    readonly month: string,
    readonly privateAddress: string,
    readonly sum: string,
  ) {}

  static createListFromResponse (data: any): Array<ChartB2BB2CData> {
    return data.map((item: any) => {
      return new ChartB2BB2CData(
        item.Jahr,
        item.Monat,
        item.Privatadresse,
        item.Sum_Betrag
      )
    })
  }
}
